jQuery(function ($) {
    $(document).ready(function () {
        initLeftSwiper();
        initRightSwiper();
        initSustainableSwiper();
        initRecyclableSwiper();

        function initLeftSwiper() {
            if ($(".verdilab-clean-beauty-swiper-left").length > 0) {
                const swiper_left = new Swiper('.verdilab-clean-beauty-swiper-left', {
                    slidesPerView: 1,
                    direction: "vertical",
                    centeredSlides: true,
                    loop: true,
                    autoplay: {
                        delay: 1000,
                    },
                    allowTouchMove: false,
                });
            }
        }

        function initRightSwiper() {
            if ($(".verdilab-clean-beauty-swiper-right").length > 0) {
                const swiper_right = new Swiper('.verdilab-clean-beauty-swiper-right', {
                    slidesPerView: 1,
                    direction: "vertical",
                    centeredSlides: true,
                    loop: true,
                    autoplay: {
                        delay: 1000,
                    },
                    allowTouchMove: false,
                });
            }
        }

        function initSustainableSwiper() {
            if ($(".verdilab-clean-beauty-sustainable-swiper").length > 0) {
                const sustainableSwiper = new Swiper('.verdilab-clean-beauty-sustainable-swiper', {
                    slidesPerView: 1,
                    spaceBetween: 30,
                    loop: true,
                    allowTouchMove: false,
                    freeMode: false,
                    effect: "fade",
                    fadeEffect: {
                        crossFade: true,
                    },
                    navigation: {
                        nextEl: ".sustainable-swiper-button-next",
                        prevEl: ".sustainable-swiper-button-prev",
                    },
                });
            }
        }

        function initRecyclableSwiper() {
            if ($(".verdilab-clean-beauty-recyclable-swiper").length > 0) {
                const sustainableSwiper = new Swiper('.verdilab-clean-beauty-recyclable-swiper', {
                    slidesPerView: 1,
                    spaceBetween: 30,
                    freeMode: false,
                    effect: "fade",
                    fadeEffect: {
                        crossFade: true,
                    },
                    navigation: {
                        nextEl: ".recyclable-swiper-button-next",
                        prevEl: ".recyclable-swiper-button-prev",
                    },
                });
            }
        }
    });
});